import { render } from "./landing-view.vue?vue&type=template&id=f2f4d57c&scoped=true"
import script from "./landing-view.vue?vue&type=script&lang=js"
export * from "./landing-view.vue?vue&type=script&lang=js"

import "./landing-view.vue?vue&type=style&index=0&id=f2f4d57c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2f4d57c"]])

export default __exports__